import React from 'react';
import noop from 'utils/noop';
import debounce from 'lodash/debounce';
import { DEFAULT_DEBOUNCE_TIME } from 'utils/helpers';
import { SemanticUI } from '@iterable/deprecated_react_components';

// type Props = {
//   /** Debounce time in milliseconds */
//   debounceTime: number,
//   /** The initial filter input value. */
//   filter: string,
//   /**
//    * Callback Function when filter is changed.
//    *
//    * ```
//    * handleChange(e, updatedProps) => {}
//    * ```
//    * @param { Object } e: The change event.
//    * @param { Object } updatedProps: Updated props containing updated filter value.
//    * @returns { void }
//    */
//   onChange: (e: {}, updatedProps: {}) => {},
//   /** Placeholder text of filter input. */
//   placeholder: string,
// };

export default class FilterInput extends React.Component {
  static defaultProps = {
    debounceTime: DEFAULT_DEBOUNCE_TIME,
    onChange: noop,
    placeholder: 'Filter...',
  };

  /**
   * Callback Function when filter is changed.
   *
   * ```
   * handleChange(e, filterProps) => {}
   * ```
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: Updated props containing updated value.
   * @returns { void }
   */
  handleChange = (e, { value }) => {
    this.props.onChange(e, { ...this.props, filter: value, value });
  };

  /**
   * Debounced version of handleChange function
   * @returns { void }
   */
  handleDebounceChange = debounce(this.handleChange, this.props.debounceTime);

  render() {
    const { debounceTime, filter, placeholder } = this.props;
    return (
      <SemanticUI.Input
        fluid
        placeholder={placeholder}
        onChange={debounceTime ? this.handleDebounceChange : this.handleChange}
        defaultValue={filter}
      >
        <input data-test="filterInput" />
      </SemanticUI.Input>
    );
  }
}
